import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  changeStageApi,
  confirmTourApi,
  createTourApi,
  createTourNotesApi,
  deleteTourApi,
  getUnitIndex,
  getUnitPricingMatrix,
  getInboxMetaData,
  getNotesByTourIdApi,
  getPricingListings,
  getTimeSlotsApi
} from '../util/Apis/inbox';

export const emptyMetaData = createAsyncThunk(
  'inbox/emptyMetaData',
  async (_args, { rejectWithValue }) => {
    return true;
  }
);
export const emptypriceListing = createAsyncThunk(
  'inbox/emptypriceListing',
  async (_args, { rejectWithValue }) => {
    return true;
  }
);

export const fetchPropertyByApartmentIdOffPlatform = createAsyncThunk(
  'inbox/fetchPropertyByApartmentIdOffPlatform',
  async ({ apartmentId }, { rejectWithValue }) => {
    try {
      return await getUnitIndex({ communityId: apartmentId });
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const fetchLeadApartmentUnits = createAsyncThunk(
  'inbox/fetchLeadApartmentUnits',
  async ({ apartmentId }, { rejectWithValue }) => {
    try {
      return await getUnitIndex({ communityId: apartmentId });
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const fetchUnitPricingMatrix = createAsyncThunk(
  'inbox/fetchUnitPricingMatrix',
  async ({ communityId, unitName, siteId }, { rejectWithValue }) => {
    try {
      return await getUnitPricingMatrix({ communityId, unitName, siteId });
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const fetchMetaData = createAsyncThunk(
  'inbox/fetchMetaData',
  async ({ leadId }, { rejectWithValue }) => {
    try {
      return await getInboxMetaData({ leadId });
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const fetchTimeSlots = createAsyncThunk(
  'inbox/fetchTimeSlots',
  async ({ communityId, leadId, tourType }, { rejectWithValue }) => {
    try {
      return await getTimeSlotsApi({ communityId, leadId, tourType });
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const fetchInboxMetaData = createAsyncThunk(
  'inbox/fetchInboxMetaData',
  async ({ leadId }, { rejectWithValue }) => {
    try {
      return await getInboxMetaData({ leadId });
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const createTour = createAsyncThunk(
  'inbox/createTour',
  async ({ data }, { rejectWithValue }) => {
    try {
      let resp = await createTourApi({ data });
      if (resp.status !== 200) {
        return;
        // return alert('error in creating the tour');
      } else {
        return resp;
      }
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
export const deleteTour = createAsyncThunk(
  'inbox/deleteTour',
  async ({ tourId, cancelReason }, { rejectWithValue }) => {
    try {
      return await deleteTourApi({ tourId, cancelReason });
      // if(resp.status === 200){
      //     return alert("tour cancelled successfully")
      // }else {
      //     return alert("error in cancelling the appointment")
      // }
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const fetchTourConfirmation = createAsyncThunk(
  'inbox/fetchTourConfirmation',
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await confirmTourApi({ id });
      // get() swallows axios errors and returns the AxiosError as a fulfilled
      // value. Surface it as a rejection so the polling effect can stop.
      if (response?.isAxiosError) {
        return rejectWithValue(response);
      }
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const createNewTourNotes = createAsyncThunk(
  'inbox/createTourNotes',
  async ({ notesPayload }, { rejectWithValue }) => {
    try {
      return await createTourNotesApi({ notesPayload });
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const getNotesByTourId = createAsyncThunk(
  'inbox/getNotesByTourId',
  async ({ notesPayload }, { rejectWithValue }) => {
    try {
      return await getNotesByTourIdApi({ id: notesPayload });
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const updateStage = createAsyncThunk(
  'inbox/updateStage',
  async ({ stagePayload }, { rejectWithValue }) => {
    try {
      return await changeStageApi({ stagePayload });
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const fetchPriceListings = createAsyncThunk(
  'inbox/fetchPriceListings',
  async ({ apartmentPayload }, { rejectWithValue }) => {
    try {
      return await getPricingListings({ apartmentPayload });
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
